import { composeIO } from 'react-compose-io'
import { regraTransformacaoFormIO } from './RegraTransformacaoForm.IO'
import RegraTransformacaoFormView from './RegraTransformacaoForm.View'

export const RegraTransformacaoForm = composeIO(RegraTransformacaoFormView, regraTransformacaoFormIO)
